import { faBullseye, faFilter, faSearch, faSquarePollVertical } from "@fortawesome/free-solid-svg-icons";
import CsrIndex from "../../View/Csr/Csr.index";
import FilterIndex from "../../View/Filter/Filter.index";
import IRouter, { IGroupedRouter } from "../Interface/IRouter";
import SearchIndex from "../../View/Search/Search.index";
import CenterCount from "../../View/CenterCount/CenterCount.index";
import CenterStatsDetails from "../../View/CenterStatsDetails/CenterStatsDetails";
import CSRReport from "../../View/CSRReport/CSRReport";
import BypassDetails from "../../View/Bypass/Bypass";
import CsrStatsIndex from "../../View/Csr/CsrStats.index";
import InvigilatorsIndex from "../../View/Invigilators/Invigilators.index";
import InvigilatorStatsIndex from "../../View/InvigilatorStats/InvigilatorStatsIndex";
import VerifiedStats from "../../View/Csr/VerifiedStats";
import Dashboard from "../../View/Dashboard/Dashboard";
import CityWiseHandeling from "../../View/CityWiseHandeling";
import { ShiftReport } from "../../View/ShiftReport/ShiftReport";
import ExceptionReport from "../../View/ExceptionReport/ExceptionReport";
import InvigilatorsDataIndex from "../../View/InvigilatorsData";
import AttendanceReport from "../../View/Attendance/AttendanceReport";
import BiometricOperatorStatsIndex from "../../View/BiometericOperatorStats/Index";
import VenueWiseReport from "../../View/Attendance/VenueWiseReport";
import FacialMisMatchData from "../../View/Bypass/FacialMismatchData";
import VerificationData from "../../View/Bypass/VerificationData";
import AttendanceStats from "../../View/CenterCount/AttendanceStats";
import PagesIndex from "../../View/Pages/Index";
import ReverificationDashboard from "../../View/Reverification/Dashboard";
import ReverificationDashboardDev from "../../View/Reverification/DashboardDev";
import ReverifyCandidates from "../../View/Bypass/ReverifyCandidates";
import NewDashboard from "../../View/Attendance/NewDashboard";
import BiometricNotmatched from "../../View/Csr/BiometricNotmatched";
import DBSSync from "../../View/Attendance/DBSSync";

const reportRoutes: IRouter[] = [
    {
        path: "center-report",
        navbarShow: true,
        element: CsrIndex,
        name: "Center Report",
        icon: faSquarePollVertical
    },
    // {
    //     path: "center-data",
    //     navbarShow: true,
    //     element: FilterIndex,
    //     name: "Center Data",
    //     icon: faFilter
    // },
    {
        path: "csr-report",
        navbarShow: true,
        element: CSRReport,
        name: "CSR Report",
        icon: faSearch
    },
    {
        path: "bypass",
        navbarShow: true,
        element: BypassDetails,
        name: "Exception Candidates",
        icon: faSearch
    },

    // {
    //     path: "exception-report",
    //     navbarShow: true,
    //     element: ExceptionReport,
    //     name: "Exception Report",
    //     icon: faSearch
    // },
    {
        path: "attendance-report",
        navbarShow: true,
        element: AttendanceReport,
        name: "Attendance Report",
        icon: faSearch
    },
    {
        path: "facial-data",
        navbarShow: true,
        element: FacialMisMatchData,
        name: "Facial Data",
        icon: faSearch
    },
    {
        path: "verification-data",
        navbarShow: true,
        element: VerificationData,
        name: "Verification Data",
        icon: faSearch
    },
    {
        path: "reverify",
        navbarShow: true,
        element: ReverifyCandidates,
        name: "Reverify Candidates",
        icon: faSearch
    },

    {
        path: "biometric-mismatch",
        navbarShow: true,
        element: BiometricNotmatched,
        name: "Biometric Mismatch",
        icon: faSquarePollVertical
    },

];

const statsRoutes: IRouter[] = [
    // {
    //     path: "csr-stats",
    //     navbarShow: true,
    //     element: CsrStatsIndex,
    //     name: "CSR Stats",
    //     icon: faSearch
    // },
    {
        path: "center-stats",
        navbarShow: true,
        element: CenterCount,
        name: "Venue Stats",
        icon: faSearch
    },
    {
        path: "attendance-stats",
        navbarShow: true,
        element: AttendanceStats,
        name: "Attendance Stats",
        icon: faSearch
    },
    {
        path: "center-stats/:shiftId/:centerId",
        navbarShow: false,
        element: CenterStatsDetails,
        name: "Center Stats",
        icon: faSearch
    },
    {
        path: "invigilator-stats",
        navbarShow: true,
        element: InvigilatorStatsIndex,
        name: "Device Report",
        icon: faSearch
    },
    {
        path: "operator-stats",
        navbarShow: true,
        element: BiometricOperatorStatsIndex,
        name: "Operator Stats",
        icon: faSearch
    },
    // {
    //     path: "invigilator-data",
    //     navbarShow: true,
    //     element: InvigilatorsDataIndex,
    //     name: "Biometric Operator Data",
    //     icon: faSearch
    // },
    {
        path: "invigilators",
        navbarShow: false,
        element: InvigilatorsIndex,
        name: "Biometric Operator",
        icon: faSearch
    },
    {
        path: "search",
        navbarShow: true,
        element: SearchIndex,
        name: "Search Student",
        icon: faSearch
    },
    // {
    //     path: "average-handling",
    //     navbarShow: true,
    //     element: CityWiseHandeling,
    //     name: "District Wise Average Handling",
    //     icon: faSearch
    // },
    {
        path: "download-shift-report",
        navbarShow: false,
        element: ShiftReport,
        name: "Shift Report",
        icon: faSearch
    }
    // ,{
    //     path: "v-attendance-report",
    //     navbarShow: true,
    //     element: VenueWiseReport,
    //     name: "Venue Wise Attendance Report",
    //     icon: faSearch
    // },
    ,{
        path: "dashboard-2",
        navbarShow: true,
        element: Dashboard,
        name: "Verification Dashboard",
        icon: faSearch
    },
    {
        path: "reverification-dashboard",
        navbarShow: true,
        element: ReverificationDashboard,
        name: "Reverification Dashboard",
        icon: faSearch
    },
    {
        path: "reverification-dashboard-dev",
        navbarShow: true,
        element: ReverificationDashboardDev,
        name: "Reverification Dashboard (dev)",
        icon: faSearch
    },
    {
        path: "dashboard-detailed",
        navbarShow: true,
        element: VenueWiseReport,
        name: "Dashboard Detailed",
        icon: faSearch
    },
    {
        path: "cet-dbs",
        navbarShow: true,
        element: DBSSync,
        name: "Cet Dbs",
        icon: faSearch
    },
];

const settingsRoutes: IRouter[] = [
    // {
    //     path: "bypass",
    //     navbarShow: true,
    //     element: BypassDetails,
    //     name: "Bypass Candidates",
    //     icon: faSearch
    // },
    // {
    //     path: "search",
    //     navbarShow: true,
    //     element: SearchIndex,
    //     name: "Search Student",
    //     icon: faSearch
    // }
]

const dashRoutes: IRouter[] = [

    {
        path: "dashboard",
        navbarShow: true,
        // element: NewDashboard,
        element: VenueWiseReport,
        name: "Dashboard",
        icon: faSearch
    },
    {
        path: "pages",
        navbarShow: false,
        element: PagesIndex,
        name: "Pages",
        icon: faSearch
    }
]

export const GroupedRoutes: IGroupedRouter[] = [
    {
        path: "/reports",
        navbarShow: true,
        name: "Exam Admission Reports",
        icon: faBullseye,
        children: [...reportRoutes]
    },
    {
        path: "/stats",
        navbarShow: true,
        name: "Individual Reports",
        icon: faBullseye,
        children: [...statsRoutes]
    },
    // {
    //     path: "/settings",
    //     navbarShow: true,
    //     name: "Settings",
    //     icon: faBullseye,
    //     children: [...settingsRoutes]
    // }
];

const mainRoutes: IRouter[] = [...reportRoutes, ...statsRoutes, ...settingsRoutes, ...dashRoutes];
export default mainRoutes;